import { SliderNext, SliderPrevious } from "@workspace/frontend-ui";

type Props = {
  direction: "left" | "right";
  className?: string;
  iconClassName?: string;
};

const CarouselButton: FC<Props> = ({ direction, className, iconClassName }) => {
  const Control = direction === "right" ? SliderNext : SliderPrevious;

  return (
    <Control
      placement="edge"
      className={className}
      iconClassName={iconClassName}
    />
  );
};

export default CarouselButton;
